import React, {useContext} from "react";
import {useForm, FormProvider} from "react-hook-form";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import * as Security from '../../../utils/auth/Security';
import * as CustomStyles from '../../styles/CustomStyles';
import * as EmployerFragment from './EmployerFragmentComponent';
import EmployerWorksites from './EmployerWorksitesComponent';
import {TabPanel, a11yProps} from "../../custom/CustomTabPanelComponent";
import BucketContext from "../../context/BucketContext";
import { RoleClient } from "../../constants/Consts";



const TabBottomButtonBar = (props) => {
    return (
        <Grid container spacing={2} sx={CustomStyles.gridStyles}>
            <Grid item xs={12} container justifyContent="flex-end" alignItems="flex-end">
                {/* {Security.isSignedInUserInRole(RoleClient.UserSpecificEmployer) ? */}
                { ( Security.isSignedInUserInRole(RoleClient.UserSpecificEmployer) || 
                    (Security.getAuthorizedClient() && Security.getAuthorizedClient() != props.employerRsvtiMB) ) ?
                    <React.Fragment></React.Fragment>
                        :
                    <Button variant="outlined" type="submit" sx={{ marginRight: 1 }}> {props.buttonLabel} </Button>
                }
            </Grid>
        </Grid>
    );
}


function EmployerTabsRenderer(props) {
    console.log('employer tab renderer');

    const bucketContext = useContext(BucketContext);

    const methods = useForm({
        defaultValues: {
            lEmployer: props.employer
        } 
    });
    const handleSubmit = methods.handleSubmit;

    const employerTabIndex = bucketContext.bucket.employerTabIndex !=null ? bucketContext.bucket.employerTabIndex : 0;

    const [tabIndex, setTabIndex] = React.useState(employerTabIndex);
    const handleTabChange = (event, newValue) => {
      setTabIndex(newValue);
      bucketContext.setBucketValue( {employerTabIndex: newValue} );
   };    

    const handleSubmitGeneralData = (data) => {
        const employer = {
            id: data.lEmployer.id,            
            generalSection: data.lEmployer.generalSection
        }
        props.patchEmployer(employer);
    }

    const handleSubmitHomeOffice = (data) => {
        const employer = {
            id: data.lEmployer.id,            
            headOffice: data.lEmployer.headOffice
        }
        props.patchEmployer(employer);
    }    

    const handleSubmitCaracterizare = (data) => {
        const employer = {
            id: data.lEmployer.id,            
            caracterizare: data.lEmployer.caracterizare,
            activitateEconomica: data.lEmployer.activitateEconomica
        }
        props.patchEmployer(employer);
    }    

    const handleSubmitActivitateProtectie = (data) => {
        const employer = {
            id: data.lEmployer.id,            
            organizareActivitateProtectie: data.lEmployer.organizareActivitateProtectie
        }
        props.patchEmployer(employer);
    }    

    const handleSubmitMedicinaMuncii = (data) => {
        const employer = {
            id: data.lEmployer.id,            
            medicinaMuncii: data.lEmployer.medicinaMuncii
        }
        props.patchEmployer(employer);
    }    

    const handleSubmitPreferences = (data) => {
        const employer = {
            id: data.lEmployer.id,            
            preference: data.lEmployer.preference
        }
        props.patchEmployer(employer);
    }
    
    return(
        <React.Fragment>

        <FormProvider {...methods} > 
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabIndex} onChange={handleTabChange} aria-label="scrollable tabs" variant="scrollable" scrollButtons="auto">
                            <Tab label="Date Generale" {...a11yProps(0)} />
                            <Tab label="Adresa Sediu" {...a11yProps(1)} />
                            <Tab label="Puncte de Lucru" {...a11yProps(2)} />
                            <Tab label="Caracterizare" {...a11yProps(3)} />
                            <Tab label="OAPP" {...a11yProps(4)} />
                            <Tab label="Medicina Muncii" {...a11yProps(5)} />
                            <Tab label="Preferinte" {...a11yProps(6)} />
                        </Tabs>
                    </Box>

                    <TabPanel value={tabIndex} index={0}>
                        <form onSubmit={handleSubmit( handleSubmitGeneralData )} id={'generalDataTabForm'}>
                            <EmployerFragment.RenderDateGeneraleSection 
                                 clients={props.clients} 
                            />
                            <TabBottomButtonBar 
                                employerId={props.employer.id} 
                                employerRsvtiMB={props.employer.generalSection.rsvtiMBClientId}
                                buttonLabel='Salveaza Date Generale' 
                            />
                        </form>
                    </TabPanel>

                    <TabPanel value={tabIndex} index={1}>
                        <form onSubmit={handleSubmit( handleSubmitHomeOffice )} id={'homeOfficeTabForm'}>
                            <EmployerFragment.RenderAdresaSediuSection />
                            <TabBottomButtonBar 
                                employerId={props.employer.id} 
                                employerRsvtiMB={props.employer.generalSection.rsvtiMBClientId}
                                buttonLabel='Salveaza Sediu' 
                            />
                        </form>
                    </TabPanel>

                    <TabPanel value={tabIndex} index={2}>
                        <EmployerWorksites 
                            employer={props.employer}  
                            worksites={props.worksites} 
                        />
                    </TabPanel>

                    <TabPanel value={tabIndex} index={3}>
                        <form onSubmit={handleSubmit( handleSubmitCaracterizare )} id={'caracterizareTabForm'}>
                            <EmployerFragment.RenderDateCaracterizareSection />
                            <TabBottomButtonBar 
                                employerId={props.employer.id} 
                                employerRsvtiMB={props.employer.generalSection.rsvtiMBClientId}
                                buttonLabel='Salveaza caracterizare' 
                            />
                        </form>
                    </TabPanel>

                    <TabPanel value={tabIndex} index={4}>
                        <form onSubmit={handleSubmit( handleSubmitActivitateProtectie )} id={'activitateProtectieTabForm'}>
                            <EmployerFragment.RenderActivitatiProtectieSection />
                            <TabBottomButtonBar 
                                employerId={props.employer.id} 
                                employerRsvtiMB={props.employer.generalSection.rsvtiMBClientId}
                                buttonLabel='Salveaza Activitate Protectie' 
                            />
                        </form>
                    </TabPanel>

                    <TabPanel value={tabIndex} index={5}>
                        <form onSubmit={handleSubmit( handleSubmitMedicinaMuncii )} id={'medicinaMunciiTabForm'}>
                            <EmployerFragment.RenderMedicinaMunciiSection />
                            <TabBottomButtonBar 
                                employerId={props.employer.id} 
                                employerRsvtiMB={props.employer.generalSection.rsvtiMBClientId}
                                buttonLabel='Salveaza Medicina Muncii' 
                            />
                        </form>
                    </TabPanel>

                    <TabPanel value={tabIndex} index={6}>
                        <form onSubmit={handleSubmit( handleSubmitPreferences )} id={'preferencesTabForm'}>
                            <EmployerFragment.RenderPreferenceSection />
                            <TabBottomButtonBar 
                                employerId={props.employer.id} 
                                employerRsvtiMB={props.employer.generalSection.rsvtiMBClientId}
                                buttonLabel='Salveaza Preferinte' 
                            />
                        </form>
                    </TabPanel>
                </Box>
        </FormProvider>
        </React.Fragment>
    );
}

export default EmployerTabsRenderer